import MuiCardHeader, { CardHeaderProps } from '@mui/material/CardHeader';

export interface ICardHeaderProps extends CardHeaderProps { }

const CardHeader = (props: ICardHeaderProps): JSX.Element => {
  return <MuiCardHeader
    {...props}
    sx={{ ...props.sx, m: 0, p: 1, pr: 2 }}
  />;
};

export default CardHeader;
